export const NAME = 'clients';



// WEBPACK FOOTER //
// ./src/modules/clients/constants.js